import _ from "lodash";
import React from "react";
import { v4 as uuidv4 } from "uuid";

interface Props {
  columnName: string;
  index: number;
  onChange?: () => void;
  selectedIdColumns?: string[];
  handleIdColumnSelect?: (arg0: string, arg1: string[], arg2: () => void) => void;
  columnsSelectable?: boolean;
  readOnly?: boolean;
}

export default function DataViewQueryResultTableHeader({
  columnName,
  index,
  onChange,
  selectedIdColumns,
  handleIdColumnSelect,
  columnsSelectable,
  readOnly,
}: Props): JSX.Element {
  return (
    <th
      key={columnName}
      scope="col"
      className={`sticky text-left text-xs font-medium text-gray-500 border-b border-gray-200 
          ${_.includes(selectedIdColumns, columnName) ? "bg-blue-50" : null}`}
    >
      <div className="flex overflow-auto min-w-[150px] hover:resize-x">
        {columnsSelectable && onChange && selectedIdColumns && handleIdColumnSelect ? (
          <input
            size={10}
            key={uuidv4()}
            id={`${index}`}
            type="checkbox"
            checked={_.includes(selectedIdColumns, columnName)}
            onChange={() => handleIdColumnSelect(columnName, selectedIdColumns, onChange)}
            className="form-checkbox my-auto mx-2 border-gray-300 cursor-pointer text-gray-800 focus:ring-primary-main"
            disabled={readOnly}
          />
        ) : null}
        <label htmlFor={`${index}`}>
          <div className="p-3 min-w-[150px]">{columnName}</div>
        </label>
      </div>
    </th>
  );
}
